import { getConfig, BannerModel } from './config/BannerConfig'

export function initializeCookieBanner() {
  const config = getConfig()
  if (config) {
    appendScript(config)
  }
}

export function appendScript({ consent_url, template_url, data_domain_script, enabled }: BannerModel) {
  if (enabled) {
    let head = document.getElementsByTagName('head')[0];
    let script = document.createElement("script");
    if (consent_url) {
      script.type = 'text/javascript';
      script.src = consent_url;
      head.appendChild(script);
      script = document.createElement("script");
    }
    script.type = 'text/javascript';
    script.src = template_url;
    script.setAttribute('data-domain-script', data_domain_script);
    script.onload = () => {
      function OptanonWrapper() { }
    };
    head.appendChild(script);
  }
}

export function clearOneTrustCookies(){
  delete_cookie("OptanonConsent");
  delete_cookie("OptanonAlertBoxClosed");
}

function delete_cookie(name: string) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
